import { render, staticRenderFns } from "./AddProduct.vue?vue&type=template&id=2752eb67&"
import script from "./AddProduct.vue?vue&type=script&lang=js&"
export * from "./AddProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddProduct.vue?vue&type=style&index=0&id=2752eb67&prod&lang=scss&"
import style1 from "./AddProduct.vue?vue&type=style&index=1&id=2752eb67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports